import { Button } from '@/components/button';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';
import styles from './medical-history-item-list.module.css';
import { Fragment } from 'react';
import { useTranslation } from '@/contexts/i18n-context';

interface MedicalHistoryItemListProps {
  items: { id: string; text: string; type?: string | null }[];
  displayType?: boolean;
  onRemove: (id: string) => void;
}

const translationBase = 'visit.medicalHistory';

export function MedicalHistoryItemList({
  items,
  displayType,
  onRemove,
}: MedicalHistoryItemListProps) {
  const { t } = useTranslation();

  if (items.length === 0) {
    return null;
  }

  return (
    <div className={styles.list}>
      {items.map((item) => (
        <Fragment key={item.id}>
          <span className={styles.listItemText}>
            {item.text}
            {displayType && item.type && (
              <span className={styles.listItemType}>{` (${item.type})`}</span>
            )}
          </span>
          <Button
            className={styles.removeButton}
            data-testid="medical-history-item-remove"
            onClick={() => onRemove(item.id)}
            variant="textOnly"
          >
            <MaterialSymbolIcon name="close" aria-label={t(`${translationBase}.remove`)} />
          </Button>
        </Fragment>
      ))}
    </div>
  );
}
